var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeployIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.39103 12.647C1.16026 13.6809 0.75 16.7496 0.75 16.7496C0.75 16.7496 3.81872 16.3393 4.85256 15.1085C5.43513 14.4193 5.42692 13.3609 4.77872 12.7209C4.45979 12.4165 4.03968 12.2406 3.59901 12.2269C3.15834 12.2133 2.72816 12.3629 2.39103 12.647Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.54357 11.4169L6.08203 8.95533C6.51866 7.82256 7.06845 6.73672 7.72306 5.71431C8.6791 4.18568 10.0103 2.92706 11.5901 2.05818C13.1699 1.18929 14.9458 0.739021 16.7487 0.750203C16.7487 2.982 16.1087 6.90405 11.8256 9.77584C10.7892 10.4312 9.6897 10.981 8.54357 11.4169Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.08303 8.95471H1.98047C1.98047 8.95471 2.43175 6.46855 3.62149 5.67265C4.95073 4.7865 7.72406 5.67265 7.72406 5.67265",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.54297 11.4169V15.5195C8.54297 15.5195 11.0291 15.0682 11.825 13.8784C12.7112 12.5492 11.825 9.77588 11.825 9.77588",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeployIcon);
export default __webpack_public_path__ + "static/media/deploy-icon.f3f986efa1e45cae7b99ecd0458ea104.svg";
export { ForwardRef as ReactComponent };